import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { hasPhotoCaptureContextUpdated, photoCaptureUpdateContextDataAction, getPhotoCaptureAssignmentSubType, getPhotoCaptureAssignmentType, getPhotoCaptureFileSizeLimit, getPhotoCaptureWorkItemStatus, getPhotoCaptureIsTermsAndConditionAccepted, getPhotoCaptureAttachmentInfo, photoCapturePhotoUploadAction, getShouldAllowMitchellIntelligent, intelligentGetPhotoCaptureFileUploadView, getShouldMoveToNextQuestion, getShouldEnableRepairShop } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestionnaireQuestionId, getIsQuestionnaireEvaluationMultiSelectAllowed, getQuestionnaireEvaluationAnswerControlType, getQuestionnaireEvaluationQuestionList, questionnaireEvaluationQuestionGetSuccessAction } from "../../../domain/questionnaireEvaluation";
import { isFileUploadModalOpen, getFileInfoState, getFileUploadMaxSizeState } from "../../../domain/file";
import { GPCRootComponent } from '../components';
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCLoadingStatus, getGPCTheme, shouldHandleFileUploadLoading, getGPCErrorStatus, getGPCInvalidFileUploadInfo } from '../selectors';
const mapStateToProps = (state) => {
    const { byId, allIds } = getFileInfoState(state);
    return {
        appTheme: getGPCTheme(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        maxImageFileSize: getPhotoCaptureFileSizeLimit(state),
        maxVideoFileSize: getFileUploadMaxSizeState(state) && getFileUploadMaxSizeState(state).maxVideoFileSize,
        assignmentSubType: getPhotoCaptureAssignmentSubType(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        workItemStatus: getPhotoCaptureWorkItemStatus(state),
        questionList: getQuestionnaireEvaluationQuestionList(state),
        questionAttributeType: getQuestionnaireEvaluationQuestionAttributeType(state),
        answerControlType: getQuestionnaireEvaluationAnswerControlType(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        fileInfoData: {
            uploadError: byId[allIds[0]] && byId[allIds[0]].uploadError,
            id: byId[allIds[0]] && byId[allIds[0]].id,
            uploadStatus: byId[allIds[0]] && byId[allIds[0]].uploadStatus,
            fileName: byId[allIds[0]] && byId[allIds[0]].fileName
        },
        isRAPFileUploadModalOpen: isFileUploadModalOpen(state),
        isMultiSelectionAllowed: getIsQuestionnaireEvaluationMultiSelectAllowed(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        isLoading: getGPCLoadingStatus(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        shouldAllowMitchellIntelligent: getShouldAllowMitchellIntelligent(state),
        view: intelligentGetPhotoCaptureFileUploadView(state),
        isErrorOccured: getGPCErrorStatus(state),
        intelligentFileUploadErrorInfo: getGPCInvalidFileUploadInfo(state),
        shouldMoveToNextQuestion: getShouldMoveToNextQuestion(state),
        shouldEnableRepairShop: getShouldEnableRepairShop(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionnaireEvaluationQuestionGetSuccessAction,
        photoCaptureUpdateContextDataAction,
        photoCapturePhotoUploadAction
    }, dispatch);
};
const mergedProps = (stateProps, dispatchProps, ownProps) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, stateProps), dispatchProps), ownProps), { shouldShowLoader: stateProps.shouldMoveToNextQuestion || shouldHandleFileUploadLoading(stateProps) });
};
const GPCRootComponentWrapper = (props) => React.createElement(GPCRootComponent, Object.assign({}, props));
export const ConnectedGPCRootComponent = connect(mapStateToProps, mapDispatchToProps, mergedProps)(GPCRootComponentWrapper);
//# sourceMappingURL=ConnectedGPCRootComponent.js.map